import * as types from './actionTypes';
import ufApi from '../api/ufApi'


export function listarUFSuccess(ufs) {
    
    return { type: types.LISTAR_UF, ufs }
}

export function listarUF() {
    return function (dispatch) {
        return ufApi.listarUF().then(resultado => {
            
            dispatch(listarUFSuccess(resultado));
        }).catch(error => {
            
            throw (error);
        });
    };
}




/** WEBPACK FOOTER **
 ** ./src/components/actions/ufActions.js
 **/